import {FC, useState} from 'react'

import {EyeHiddenIcon} from '@/components/common/icons/EyeHiddenIcon'
import {EyeIcon} from '@/components/common/icons/EyeIcon'
import {TextInput} from '@/components/inputs/TextInput'
import {useAuthContent} from '@/content/user/authentication'
import {useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'

type PasswordInputProps = {
  name: string
  hasError?: boolean
}

export const PasswordInput: FC<React.PropsWithChildren<PasswordInputProps>> = ({
  name,
  hasError,
}) => {
  const {t} = useTranslation()
  const [isPasswordVisible, setIsPasswordVisible] = useState(false)
  const {passwordPlaceholder} = useAuthContent()

  return (
    <>
      <div className="input-wrapper">
        <TextInput
          name={name}
          type={isPasswordVisible ? 'text' : 'password'}
          hasError={hasError}
          placeholder={t(passwordPlaceholder)}
        />
        <button
          type="button"
          className="icon"
          onClick={() => setIsPasswordVisible(!isPasswordVisible)}
        >
          {isPasswordVisible ? <EyeIcon /> : <EyeHiddenIcon />}
        </button>
      </div>

      <style jsx>{`
        .input-wrapper {
          position: relative;
        }
        .icon {
          position: absolute;
          display: flex;
          right: 10px;
          top: 50%;
          padding: ${theme.spacing[0.5]};
          transform: translateY(-50%);
        }
      `}</style>
    </>
  )
}
